export const FLOORPLAN_CONFIG_MAPPING  = {
  // ceiling: 'ceiling',
  height_lens: 'height_lens',
  floors: 'floor',
};

// teaser video
export const BACKGROUND_AUDIO = 'https://www.eyespy360.com/common/audio/background_audio.mp3';

export const size4K = {
    width: 3840,
    height: 2160
}
// Ably
export const publishKey = '6_oFnA.zqol3Q:kHrh-t9bn_wz5hZo';

// ACTIONS project
export const GEOIP_URL = '/p/ip.pl';

// METRIC TYPE
export const AREA = 'AREA';
export const LENGTH = 'LENGTH';
// WEBRTC PROVIDER
export const OPENTOK = 'opentok';
export const TOKBOX = 'tokbox';
// WEBRTC ACTIONS
export const SCREEN_SHARE = 'SCREEN_SHARE';


//COUNTY CODE WITH IMPERIAL SYSTEM http://chartsbin.com/view/d12
export const COUNTRY_IMPERIAL_SYSTEM = ['Ukraine', 'Thailand', 'China', 'Indonesia', 'United Kingdom',
  'Malaysia', 'United States', 'North Korea', 'Sri Lanka', 'Hong Kong', 'Taiwan', 'Macau', 'Liberia', 'Myanmar'];
//UNITS
export const UNIT_MILLIMETER = 'mm';
export const UNIT_CENTIMETER = 'cm';
export const UNIT_METER = 'm';
export const UNIT_METER_SQUARE  = 'm2';
export const UNIT_INCH = 'in';
export const UNIT_FOOT = 'ft';
export const UNIT_FOOT_SQUARE  = 'ft2';
export const UNIT_MILE = 'mi';

export const UNITS_LENGTH = [
  UNIT_MILLIMETER,
  UNIT_CENTIMETER,
  UNIT_METER,
  UNIT_INCH,
  UNIT_FOOT,
  UNIT_MILE
];

export const UNIT_COEF = {
  [UNIT_MILLIMETER]: 0.1,
  [UNIT_CENTIMETER]: 1,
  [UNIT_METER]: 100,
  [UNIT_INCH]: 2.54,
  [UNIT_FOOT]: 30.48,
  [UNIT_MILE]: 160934.4,
};

// cdn url
export const CDN_URL_SHARE_MIN_JS = '//www.eyespy360.com/library/share-min.js';
export const REGEX_ROOM_URL = /(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/?\n]+(\/e).*(\/e).*(room=).*)/g;
export const isPortrait = window.innerHeight >= window.innerWidth;
export const PREVIEW_SIZE = {
  width: isPortrait ? 160 : 240,
  height: isPortrait ? 160 : 240,
}

export const MAXIMUM_PIXEL_IOS = 10000000;
